import React from 'react';
import { useFormContext } from 'react-hook-form';
import { DealStatus } from '@trnsact/trnsact-shared-types';
import { SelectField } from 'components/form/rhf';
import { FinanceFilters } from '../types';

const options = [
  { label: 'All', value: 'ALL' },
  { label: 'Closed Won', value: DealStatus.ClosedWon },
  { label: 'Pipeline', value: DealStatus.Pipeline },
];

export const FinanceDealStatus = () => {
  const { control } = useFormContext<FinanceFilters>();

  return (
    <SelectField
      size="small"
      variant="outlined"
      name="DEAL_STATUS"
      label="Deal Status"
      control={control}
      options={options}
    />
  );
};
